import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  overflow: hidden;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 16px;
    cursor: default;
      
      .dropdown-icon {
        height: 20px;
        width: 20px;
        cursor: pointer;
        text-align: center;
      }

      .widget-menu {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 160px;
        background: ${(props) => props.theme.colors.widget_background};
        box-shadow: ${(props) => props.theme.shadows.dropdown};
        border-radius: 12px;
        
        li {
          display: flex;
          align-items: center;
          gap: 8px;
          width: 100%;
          padding: 17px 16px;
          font-family: ManropeBold, sans-serif;
          font-size: 13px;
          line-height: 18px;
          cursor: pointer;

          button {
            display: contents;
          }
          
          &:hover {
            background: ${(props) => props.theme.colors.inactive};
          }
          
          &:first-child{
            border-radius: 12px 12px 0 0;
          }

          &:last-child{
            border-radius: 0 0 12px 12px;
          }
        }
      }
    }

  .notes-container {
    display: flex;
    flex-direction: column;
    cursor: default;
    justify-content: space-between;

    p {
      text-align: center;
      margin: 30px 0;
      color: ${(props) => props.theme.colors.inactive}
    }
  }

  button {
    background-color: ${(props) => props.theme.colors.outline};
  }
`;

export default { Wrapper };
